import React from "react";
import {twMerge} from "tailwind-merge";
import SmartIcon from "./SmartIcon.tsx";
import {IconType} from "react-icons";

type FieldProps = {
  className?: string;
  classInput?: string;
  label?: string;
  textarea?: boolean;
  note?: string;
  type?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  icon?: string | IconType;
  numberTypeMin?: number;
  numberTypeMax?: number;
  numberTypeStep?: number;
  disabled?: boolean;
};

const Field: React.FC<FieldProps> = (
  {
    className,
    classInput,
    label,
    textarea,
    note,
    type,
    value,
    onChange,
    placeholder,
    required,
    icon,
    numberTypeMin,
    numberTypeMax,
    numberTypeStep,
    disabled = false,
  }: FieldProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const remainingChars: number = 880 - value.length;
    if (remainingChars <= 0 && event.key !== "Backspace") {
      event.preventDefault();
    }
  };

  const remainingChars: number = 880 - value.length;

  return (
    <div className={`${className}`}>
      <div className="">
        {label && (
          <div className="flex mb-2 base2 font-semibold">
            {label}
            {textarea && (
              <span className="ml-auto pl-4 text-n-400/50">
                {remainingChars}
              </span>
            )}
          </div>
        )}
        <div className="relative">
          {textarea ? (
            <textarea
              className={`w-full h-24 px-3.5 py-3 bg-n-200 border-2 border-n-200 rounded-xl base2  text-n-700 outline-none transition-colors placeholder:text-n-400/50 focus:bg-transparent resize-none dark:bg-n-600 dark:border-n-600 dark:text-n-300 dark:focus:bg-transparent ${
                icon && "pl-[3.125rem]"
              } ${
                value !== "" && "bg-transparent border-n-300/50"
              }`}
              value={value}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => !disabled && onChange(e)}
              onKeyDown={(e) => handleKeyDown(e)}
              placeholder={placeholder}
              required={required}
              disabled={disabled}
            ></textarea>
          ) : (
            <input
              name={"input-field" + Math.random().toString(36).substring(2, 15)}
              className={twMerge(
                `w-full h-13 px-3.5 bg-n-200 border-2 border-n-200 rounded-xl base2  text-n-700 outline-none transition-colors placeholder:text-n-400/50 focus:bg-transparent dark:bg-n-600 dark:border-n-600 dark:text-n-300 dark:focus:bg-transparent ${
                  icon && "pl-[3.125rem]"
                } ${
                  value !== "" &&
                  "bg-transparent border-n-300/50"
                } ${classInput}`
              )}
              type={type || "text"}
              value={value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => !disabled && onChange(e)}
              placeholder={placeholder}
              required={required}
              disabled={disabled}
              min={type === 'number' && numberTypeMin ? numberTypeMin : undefined}
              max={type === 'number' && numberTypeMax ? numberTypeMax : undefined}
              step={type === 'number' && numberTypeStep ? numberTypeStep : undefined}
            />
          )}
          {icon && (
            <SmartIcon
              className={`absolute top-3.5 left-4 fill-n-400/50 pointer-events-none transition-colors ${
                value !== "" && "fill-n-400"
              }`}
              name={icon}
            />
          )
          }
        </div>
        {note && <div className="mt-2 base2 text-n-400/50">{note}</div>}
      </div>
    </div>
  );
};

export default Field;
